/*
  Mattress Matchmaker - Synerise integration
  ITP-5348 | MVP
  Uses same card HTML structure as ba-synerise-recommendations.js
  ATC handled by theme's product-form custom element
*/
(function () {
  'use strict';

  var SELSEY_DESIGN_BRAND = 'selsey_design';
  var MAX_ITEMS = 3;
  var CURRENCY = window.CURRENCY_SYMBOL || 'z\u0142';
  var API_TIMEOUT = 5000;
  var _escDiv = document.createElement('div');

  function init() {
    var section = document.getElementById('mattress-matchmaker');
    if (!section) return;

    var campaignId = section.dataset.campaignId;
    var productId = section.dataset.productId;
    var trackerKey = window.SYNERISE_TRACKER_KEY;
    var apiBase = window.SYNERISE_API_BASE || 'https://api.synerise.com';
    var showCechy = section.dataset.showCechy !== 'false';
    var sdBadgeText = section.dataset.sdBadgeText || 'SELSEY DESIGN';

    if (!campaignId || !productId || !trackerKey) {
      return;
    }

    var uuid = getSnrsUuid() || 'anonymous';

    var url = apiBase
      + '/recommendations/v2/recommend/campaigns/' + campaignId
      + '?token=' + trackerKey
      + '&clientUUID=' + encodeURIComponent(uuid)
      + '&itemId=' + encodeURIComponent(productId);

    var controller = new AbortController();
    var timeoutId = setTimeout(function () { controller.abort(); }, API_TIMEOUT);

    fetch(url, { signal: controller.signal })
      .then(function (res) {
        clearTimeout(timeoutId);
        if (!res.ok) throw new Error('Synerise API error: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var items = (data.data || []).slice(0, MAX_ITEMS);
        if (items.length === 0) return;

        renderItems(section, items, showCechy, sdBadgeText);
        if (showCechy) loadCechyForSD(section);
        trackView(data.extras);
      })
      .catch(function (err) {
        clearTimeout(timeoutId);
        if (err.name !== 'AbortError') {
          console.warn('[Matchmaker] Failed to load recommendations:', err);
        }
      });
  }

  function getSnrsUuid() {
    var match = document.cookie.match(/(?:^|;\s*)_snrs_uuid=([^;]*)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function renderItems(section, items, showCechy, sdBadgeText) {
    section.querySelectorAll('.mm__panel, .mm__grid--skeleton').forEach(function (el) { el.remove(); });

    var tabs = section.querySelector('.mm__tabs');
    if (tabs) tabs.style.display = 'none';

    var container = section.querySelector('.mm__container');
    var footerLink = section.querySelector('.mm__footer-link');

    var wrapper = section.closest('.synerise-recommendations-wrapper')
      || document.querySelector('.synerise-recommendations-wrapper');
    var config = readConfig(wrapper);

    var grid = document.createElement('div');
    grid.className = 'mm__grid';

    items.sort(function (a, b) {
      var aAttrs = a.attributes || {};
      var bAttrs = b.attributes || {};
      var aSD = aAttrs.marka === SELSEY_DESIGN_BRAND ? 0 : 1;
      var bSD = bAttrs.marka === SELSEY_DESIGN_BRAND ? 0 : 1;
      return aSD - bSD;
    });

    items.forEach(function (item) {
      grid.appendChild(createCard(item, config, showCechy, sdBadgeText));
    });

    if (footerLink) {
      container.insertBefore(grid, footerLink);
    } else {
      container.appendChild(grid);
    }

    /* Upgrade dynamic product-form custom elements */
    if (typeof customElements !== 'undefined') {
      grid.querySelectorAll('form[is="product-form"]').forEach(function (form) {
        customElements.upgrade(form);
      });
    }

    /* Show section and anchor (hidden by default to prevent CLS) */
    section.style.display = '';
    var anchor = document.querySelector('.mm-anchor');
    if (anchor) anchor.style.display = '';
  }

  function readConfig(wrapper) {
    if (!wrapper) return {
      installmentCount: 10,
      omnibusText: 'Najni\u017csza cena z 30 dni przed obni\u017ck\u0105',
      ratLabel: 'rat 0%',
      fromLabel: '',
      soldOutText: 'Wyprzedane',
      starSrc: 'https://trustmate.io/images/widgets/rating/stars/star-34.svg'
    };
    return {
      installmentCount: parseInt(wrapper.dataset.installmentCount || '10', 10),
      omnibusText: wrapper.dataset.omnibusText || '',
      ratLabel: wrapper.dataset.ratLabel || 'rat 0%',
      fromLabel: wrapper.dataset.fromLabel || '',
      soldOutText: wrapper.dataset.soldOutText || 'Wyprzedane',
      starSrc: wrapper.dataset.trustmateStarSrc || 'https://trustmate.io/images/widgets/rating/stars/star-34.svg'
    };
  }

  function createCard(item, config, showCechy, sdBadgeText) {
    var attrs = item.attributes || {};
    var isSD = attrs.marka === SELSEY_DESIGN_BRAND;
    var variantId = attrs.variant_id || '';
    var sellasistId = attrs.sellasist_id || attrs.variant_id || '';
    var seria = attrs.seria || '';
    var imageUrl = cleanImageUrl(item.imageLink || '');
    var link = item.link || '#';
    var categories = item.category ? item.category.replace(/ > /g, '/') : '';

    var currentPrice = item.effectivePrice || (item.price && item.price.value) || 0;
    var salePrice = item.salePrice ? (item.salePrice.value || item.salePrice) : 0;
    var prices = [currentPrice, salePrice].filter(function (p) { return p > 0; });
    var finalPrice = prices.length > 0 ? Math.min.apply(null, prices) : 0;
    var comparePrice = prices.length >= 2 ? Math.max.apply(null, prices) : null;
    var isOnSale = comparePrice && comparePrice > finalPrice;
    var comparePriceStr = comparePrice ? '' + Math.round(comparePrice) : '';

    var rating = parseFloat(attrs.average_grade) || 0;
    var reviewCount = parseInt(attrs.reviews_count || '0', 10);

    var omnibusPrice = attrs.omnibus_price;
    var hasOmnibus = omnibusPrice && omnibusPrice !== '0' && omnibusPrice !== '0.0';

    var installmentCount = config.installmentCount || 10;
    var monthlyPayment = Math.round(finalPrice / installmentCount);

    var secondImage = '';
    if (Array.isArray(item.additionalImageLinks) && item.additionalImageLinks.length > 0) {
      var found = item.additionalImageLinks.find(function (img) { return img !== item.imageLink; });
      secondImage = cleanImageUrl(found || item.additionalImageLinks[0] || '');
    }

    var isAvailable = item.availability !== false && parseFloat(attrs.stan_magazynowy || '0') > 0;
    var formId = 'mm-atc-form-' + variantId;
    var btnId = 'mm-atc-btn-' + variantId;

    var card = document.createElement('div');
    card.className = 'mm-card-wrapper';

    if (isSD) {
      var handleMatch = link.match(/\/products\/([^?#]+)/);
      if (handleMatch) card.dataset.handle = handleMatch[1];
      card.dataset.isSd = 'true';
    }

    var html = '';

    /* --- Card link wrapper --- */
    html += '<a href="' + esc(link) + '" class="synerise-item">';

    /* --- Image area --- */
    html += '<div class="synerise-item__img" style="padding:0;">';

    if (isSD) {
      html += '<div class="product-card__badge">';
      html += '<span class="f-badge f-badge--selsey" aria-hidden="true">' + esc(sdBadgeText) + '</span>';
      html += '</div>';
    }

    html += '<div class="product-card__image-wrapper' + (secondImage ? '' : ' product-card__image-wrapper--main-only') + '">';
    html += '<div class="media-wrapper product-card__image product-card__image--main" style="--aspect-ratio:1/1">';
    html += '<img src="' + esc(imageUrl) + '" alt="' + esc(item.title || '') + '" loading="lazy">';
    html += '</div>';
    if (secondImage) {
      html += '<div class="media-wrapper product-card__image product-card__image--second inset-full hidden md:block" style="--aspect-ratio:1/1">';
      html += '<img class="absolute inset-0 w-full h-full" style="object-fit:cover;object-position:center;" src="' + esc(secondImage) + '" alt="' + esc(item.title || '') + '" loading="lazy">';
      html += '</div>';
    }
    html += '</div>'; /* close image-wrapper */

    /* --- ATC form inside image area (same as existing recs) --- */
    html += '<form method="post" action="/cart/add" id="' + esc(formId) + '" accept-charset="UTF-8" class="product-card__actions product-card__main-actions" enctype="multipart/form-data" novalidate data-type="add-to-cart-form" is="product-form">';
    html += '<input type="hidden" name="form_type" value="product">';
    html += '<input type="hidden" name="utf8" value="&#x2713;">';
    html += '<input type="hidden" name="id" value="' + esc(variantId) + '" class="product-variant-id">';
    html += '<input type="hidden" name="properties[_sellasist_id]" value="' + esc(sellasistId) + '">';
    html += '<input type="hidden" name="properties[_categories]" value="' + esc(categories) + '">';
    html += '<input type="hidden" name="properties[_compare_at_price]" value="' + esc(comparePriceStr) + '">';
    html += '<button id="' + esc(btnId) + '" type="submit" name="add" aria-label="Dodaj do kompletu" class="product-card__atc product-card__action-button btn btn--white' + (isAvailable ? '' : ' product-card__action-button--full') + '"' + (isAvailable ? '' : ' disabled') + '>';
    html += '<div class="btn__text flex gap-1 items-center">';
    if (isAvailable) {
      html += '<span class="product-card__atc-icon product-card__action-icon inline-flex">';
      html += '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M5.90002 17.75H7.90002V19.75H5.90002V21.75H3.90002V19.75H1.90002V17.75H3.90002V15.75H5.90002V17.75ZM18.6774 7.81152L22.1002 7.8125V9.8125L20.9332 9.81152L20.1764 18.8955C20.133 19.4135 19.7001 19.8123 19.1803 19.8125H9.60022V17.8125H18.2594L18.9264 9.81152L5.27307 9.8125L5.64319 14.25H3.63635L3.26624 9.81152L2.10022 9.8125V7.8125L5.52209 7.81152L8.73401 2.25L10.4664 3.25L7.83264 7.81152H16.3668L13.734 3.25L15.4664 2.25L18.6774 7.81152ZM9.10022 15.8125H7.10022V11.8125H9.10022V15.8125ZM13.1002 15.8125H11.1002V11.8125H13.1002V15.8125ZM17.1002 15.8125H15.1002V11.8125H17.1002V15.8125Z" fill="white"/></svg>';
      html += '</span>';
    } else {
      html += '<span class="product-card__atc-text product-card__action-text">' + esc(config.soldOutText) + '</span>';
    }
    html += '</div>';
    html += '<div class="loading__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner icon icon--extra-medium" viewBox="0 0 66 66"><circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle></svg></div>';
    html += '</button>';
    html += '</form>';

    html += '</div>'; /* close synerise-item__img */

    /* --- Series --- */
    if (seria) {
      html += '<span class="product-card__seria">' + esc(seria) + '</span>';
    }

    /* --- Title --- */
    html += '<h3 class="synerise-item__title">';
    html += '<span class="reversed-link block"><span class="reversed-link__text">' + esc(item.title || '') + '</span></span>';
    html += '</h3>';

    /* --- Cechy placeholder (SD only, if enabled) --- */
    if (isSD && showCechy) {
      html += '<div class="mm-cechy" data-cechy-target style="min-height:24px;margin-bottom:8px;"></div>';
    }

    /* --- Trustmate stars --- */
    html += '<div class="product-card__trustmate-target">';
    html += renderTrustmate(rating, reviewCount, config.starSrc);
    html += '</div>';

    /* --- Price --- */
    html += '<div class="f-price' + (isOnSale ? ' f-price--on-sale' : '') + '">';
    html += '<div class="f-price__regular">';
    html += '<span class="f-price-item f-price-item--regular">' + (comparePrice ? fmtPrice(comparePrice) : fmtPrice(finalPrice)) + ' ' + CURRENCY + '</span>';
    html += '</div>';
    html += '<div class="f-price__sale">';
    html += '<span class="f-price-item f-price-item--sale">' + fmtPrice(finalPrice) + ' ' + CURRENCY + '</span>';
    if (comparePrice) {
      html += '<span class="f-price-item f-price-item--regular"><s>' + fmtPrice(comparePrice) + ' ' + CURRENCY + '</s></span>';
    }
    html += '</div>';
    html += '</div>'; /* close f-price */

    /* --- Omnibus --- */
    if (hasOmnibus) {
      html += '<p class="synerise-item__omnibus">' + esc(config.omnibusText) + ' ' + Math.round(parseFloat(omnibusPrice)) + ' ' + CURRENCY + '</p>';
    }

    /* --- Installments --- */
    if (finalPrice > 0) {
      html += '<div class="buy-in-installments__price">';
      html += '<strong>' + fmtPrice(monthlyPayment) + ' ' + CURRENCY + '</strong>&nbsp;x ' + installmentCount + ' ' + esc(config.ratLabel);
      html += '</div>';
    }

    html += '<span class="product-card__separator"></span>';
    html += '</a>'; /* close synerise-item */

    card.innerHTML = html;

    return card;
  }

  /* --- Cechy loading for Selsey Design cards --- */
  function loadCechyForSD(section) {
    var sdCards = section.querySelectorAll('.mm-card-wrapper[data-is-sd="true"]');
    sdCards.forEach(function (card) {
      var handle = card.dataset.handle;
      var target = card.querySelector('[data-cechy-target]');
      if (!handle || !target) return;

      fetch('/products/' + handle + '?sections=mattress-cechy-data')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var html = sections['mattress-cechy-data'] || '';
          var temp = document.createElement('div');
          temp.innerHTML = html;
          var script = temp.querySelector('[data-mm-cechy]');
          if (!script) return;

          try {
            var cechy = JSON.parse(script.textContent);
            if (!cechy || cechy.length === 0) return;

            var chipsHtml = '<div style="display:flex;flex-wrap:wrap;gap:4px;">';
            cechy.forEach(function (c) {
              chipsHtml += '<span style="display:inline-flex;align-items:center;gap:4px;padding:4px 8px;font-size:12px;color:#333;border:1px solid #e5e5e5;border-radius:100px;white-space:nowrap;">';
              if (c.icon) {
                chipsHtml += '<img src="' + esc(c.icon) + '" width="16" height="16" loading="lazy" alt="" style="flex-shrink:0;">';
              }
              chipsHtml += '<span>' + esc(c.label) + '</span>';
              chipsHtml += '</span>';
            });
            chipsHtml += '</div>';
            target.innerHTML = chipsHtml;
          } catch (e) {
            console.warn('[Matchmaker] Failed to parse cechy:', e);
          }
        })
        .catch(function () {
          /* silent fail - card renders without cechy */
        });
    });
  }

  function renderTrustmate(rating, reviewCount, starSrc) {
    var hasReviews = rating > 0 && reviewCount > 0;
    var displayRating = hasReviews ? Math.min(Math.max(rating, 0), 5) : 0;

    var stars = '';
    for (var i = 0; i < 5; i++) {
      var fill = hasReviews ? Math.max(Math.min(displayRating - i, 1), 0) : 0;
      var cls = fill >= 1 ? 'synerise-trustmate__star synerise-trustmate__star--full'
        : fill <= 0 ? 'synerise-trustmate__star synerise-trustmate__star--empty'
        : 'synerise-trustmate__star synerise-trustmate__star--partial';
      var style = (fill > 0 && fill < 1) ? ' style="--trustmate-star-fill:' + Math.round(fill * 100) + '%;"' : '';

      if (fill > 0 && fill < 1) {
        stars += '<span class="' + cls + '"' + style + '>'
          + '<span class="synerise-trustmate__star-layer synerise-trustmate__star-layer--dimmed"><img src="' + esc(starSrc) + '" width="40" height="38" loading="lazy" alt=""></span>'
          + '<span class="synerise-trustmate__star-layer synerise-trustmate__star-layer--filled"><img src="' + esc(starSrc) + '" width="40" height="38" loading="lazy" alt=""></span>'
          + '</span>';
      } else {
        stars += '<span class="' + cls + '"><img src="' + esc(starSrc) + '" width="40" height="38" loading="lazy" alt=""></span>';
      }
    }

    var text = hasReviews
      ? rating.toFixed(1) + '<span>(' + reviewCount + ')</span>'
      : '<span>(' + reviewCount + ')</span>';

    return '<div class="synerise-trustmate' + (hasReviews ? '' : ' synerise-trustmate--no-reviews') + '">'
      + '<div class="synerise-trustmate__stars">' + stars + '</div>'
      + '<div class="synerise-trustmate__text">' + text + '</div>'
      + '</div>';
  }

  function cleanImageUrl(url) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.delete('pad_color');
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function fmtPrice(value) {
    return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  function esc(str) {
    if (!str) return '';
    _escDiv.textContent = str;
    return _escDiv.innerHTML;
  }

  function trackView(extras) {
    if (!extras || !extras.correlationId) return;
    try {
      if (typeof SR !== 'undefined' && SR.event) {
        SR.event.trackCustomEvent('recommendation.view', {
          campaignId: extras.campaignId,
          correlationId: extras.correlationId
        });
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();